import { InvoiceFilter } from "../types";
import { InvoiceListData, GetInvoiceParams } from "../types";
import { User } from "../../../auth/types";
import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

const getInvoiceWebApi = (
  user: User,
  page: number,
  itemsPerPage: number,
  filter: InvoiceFilter
) => {
  const params: GetInvoiceParams = {
    userid: user.userId,
    fromrow: page * itemsPerPage,
    numofrows: itemsPerPage,
    clientid: filter?.client?.cliId,
    datefrom: getParamsDateString(filter.datefrom),
    dateto: getParamsDateString(filter.dateto),
  };

  return webApiWithResponse<InvoiceListData[]>({
    method: "GET",
    url: "accounting/getinvoicelist",
    params,
  });
};

export default getInvoiceWebApi;
